import "./print.css";

const Undertaking = () => {
  return (
    <>
      <div style={{ border: "1px solid grey", fontSize: 11, padding: "8px" }}>
        <p style={{ fontWeight: 700 }}>UNDERTAKING BY THE CUSTOMER:</p>
        <ol>
          <li>
            eChargeBays has not connected the charger side cable to the charger side MCB and the
            customer will not get this connection made on his own till the time the new meter is
            installed/power load is enhanced/ any other aspect related to customer side SOW is
            corrected
          </li>
          <li>
            EVSE (Charger supplier) representative has not yet commissioned the charger and the
            customer will not make a request to EVSE for commissioning of charger at a later date.
            The request for commissioning will be made by eChargeBays once the new meter is
            installed/ SOW is completed and the connections are made by eChargeBays
          </li>
          <li>
            Customer will not use the installed charger for charging the vehicle under any
            circumstances. Charger has been installed, on this site, despite no sufficient load, on
            specific request from the customer & which will help in expediting the installation of
            new meter / enhancing power load / completion of customer side SOW
          </li>
          <li>
            eChargeBays will be informed once the new meter is installed / SOW is completed and
            delivery of car taken. eChargeBays representative will visit customer location to make
            the connections from the charger to the MCB and also coordinate with the EVSE concerned
            to get the charger commissioned. At that time if it is found that the charger or MCB has
            been tampered with then eChargeBays bears no responsibility for connecting the charger
            and the customer will have to do this on his own
          </li>
        </ol>
      </div>
    </>
  );
};

export default Undertaking;
